import { Roi } from './../../model/roi';
import { ParametersService } from './../../service/parameters.service';
import { Style } from './../../model/settings.model';
import { Component, OnInit, Input, OnChanges, SimpleChanges, AfterViewChecked, AfterViewInit } from '@angular/core';
import { RoiAnalysis } from '../../model/damage.model';
import { fabric } from 'fabric_gesture';

@Component({
  selector: 'app-micro-canvas',
  templateUrl: './micro-canvas.component.html',
  styleUrls: ['./micro-canvas.component.less']
})
export class MicroCanvasComponent implements AfterViewInit, OnChanges {

  private canvas: fabric.Canvas;
  @Input() roi: RoiAnalysis;
  style: Style
  firstTime: string[] = []
  image
  zoom = true

  constructor(private readonly _parametersService: ParametersService) {
    this.style = this._parametersService.getAll().style;
    if (this._parametersService.getAll().accessibility && this._parametersService.getAll().accessibility.fastTrackZoom !== undefined)
      this.zoom = this._parametersService.getAll().accessibility.fastTrackZoom
    if (!this.style)
      this.style = { damageColor: 'white', newDamageColor: 'red', dashboard: [], contrast: 0, gamma: 1, saturation: 0 };
  }

  private resizeCanvas() {
    const container = document.getElementById('canvasContainer').getBoundingClientRect()
    console.log('Resize : ', container);
    this.canvas.setHeight(container.height);
    this.canvas.setWidth(container.width);
  }

  renderCanvas() {
    let imgSource = this.roi.bestImageUrl.hd
    console.log('image hd', this.roi);
    fabric.Image.fromURL(imgSource, image => {
      if (image._element !== null) {
        this.image = image
        this.addImageAndRoi()
      } else {
        imgSource = this.roi.bestImageUrl.mini
        fabric.Image.fromURL(imgSource, image => {
          this.image = image
          if (image._element !== null)
            this.addImageAndRoi()
        }, { crossOrigin: 'Anonymous' });
      }
    }, { crossOrigin: 'Anonymous' });
  }

  addImageAndRoi() {
    if (this.canvas === undefined || this.image === undefined) return
    this.image.selectable = false;
    this.image.selection = false;
    this.canvas.setZoom(1);
    this.canvas.clear();
    // Initializing video
    if (this.canvas.getWidth() * this.image.getOriginalSize().height > this.image.getOriginalSize().width * this.canvas.getHeight())
      this.image.scaleToHeight(this.canvas.getHeight());
    else
      this.image.scaleToWidth(this.canvas.getWidth());

    this.canvas.add(this.image)
    this.image.center();
    this.image.setCoords();

    let strokeWidth = 2
    let radius = this.roi.radius * this.image.getScaledWidth()

    const colorRoiAuto = this.style.damageColor ? this.style.damageColor : 'white';
	let roiCircle 
	if ( !this.roi.width)
 	{ roiCircle = new fabric.Circle({
		id: 1,
		left: this.roi.centerX * this.image.getScaledWidth() + this.image.left + strokeWidth,
		top: this.roi.centerY * this.image.getScaledHeight() + this.image.top + strokeWidth,
		fill: 'transparent',
		radius: radius,
		strokeWidth: strokeWidth,
		strokeDashArray: undefined,
		stroke: colorRoiAuto,
		selectable: false,
		originX: 'center',
		originY: 'center',
		draggable: false,
		lockRotation: true,
		hasControls: false
	  });
 	}
 
  else
	{roiCircle =  new fabric.Rect({
	  id: 1,
	  left: this.roi.centerX * this.image.getScaledWidth() + this.image.left + strokeWidth,
	  top: this.roi.centerY * this.image.getScaledHeight() + this.image.top + strokeWidth,
	  fill: 'transparent',
	  width: this.roi.width * this.image.getScaledWidth(),
	  height: this.roi.height * this.image.getScaledHeight(),
	  strokeWidth,
	  strokeDashArray: undefined,
	  stroke: colorRoiAuto,
	  selectable: false,
	  originX: 'center',
	  originY: 'center',
	  draggable: false,
	  lockRotation: true,
	  hasControls: false
	});}
	this.canvas.add(roiCircle)
    this.smoothZoom()
  }

  smoothZoom() {
    if (!this.zoom) return
    let strokeWidth = 2
    if (!this.firstTime.includes(this.roi.damagePtr.id)) {
      this.firstTime.push(this.roi.damagePtr.id)
      setTimeout(() => {
        for (let i = 1.1; i <= 6; i = i + 0.01) {
          setTimeout(() => {
            let x = this.roi.centerX * this.image.getScaledWidth() + this.image.left - strokeWidth
            let y = this.roi.centerY * this.image.getScaledHeight() + this.image.top - strokeWidth
            this.canvas.zoomToPoint({ x, y }, i);
          }, 5 * (i - 1));
        }
      }, 1000);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.roi) {
      console.log('change roi');
      this.image = undefined
      if (this.canvas)
        this.canvas.clear()
      this.resetView()
      this.renderCanvas()
    }
  }

  resetView() {
    if (this.canvas === undefined) return;
    this.canvas.setZoom(1);
    this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    this.canvas.requestRenderAll();
  }

  private gestureFabric() {
    // For zoom on image
    let zoomStartScale
    this.canvas.on('touch:gesture', function (opt) {
      if (opt.e.touches && opt.e.touches.length === 2) {
        var point = new fabric.Point(opt.self.x, opt.self.y);
        if (opt.self.state == "start") {
          zoomStartScale = this.getZoom();
        }
        var delta = zoomStartScale * opt.self.scale;
        this.zoomToPoint(point, delta);
      }
    });
    this.canvas.on('mouse:wheel', function (opt) {
      const delta = -opt.e.deltaY;
      let zoom = this.getZoom();
      zoom *= 1 + delta / 200;
      if (zoom > 20) zoom = 20;
      if (zoom < 1) zoom = 1;
      this.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });

    // For move canvas
    this.canvas.on('mouse:down', (opt) => {
      const evt = opt.e;
      this.canvas.lastPosX = evt.clientX;
      this.canvas.lastPosY = evt.clientY;
      this.canvas.requestRenderAll();
    });

    this.canvas.on('touch:drag', (opt) => {
      const e = opt.e;
      if (e.type === 'mousemove') {
        const e = opt.e;
        this.canvas.viewportTransform[4] += e.clientX - this.canvas.lastPosX;
        this.canvas.viewportTransform[5] += e.clientY - this.canvas.lastPosY;
        this.canvas.requestRenderAll();
        this.canvas.lastPosX = e.clientX;
        this.canvas.lastPosY = e.clientY;
      } else if (e.type === 'touchmove' && opt.e.touches.length === 1) {
        let currentX = e.touches[0].clientX;
        let currentY = e.touches[0].clientY;
        let xChange = currentX - this.canvas.lastPosX;
        let yChange = currentY - this.canvas.lastPosY;
        if ((Math.abs(currentX - this.canvas.lastPosX) <= 50)
          && (Math.abs(currentY - this.canvas.lastPosY) <= 50)) {
          var delta = new fabric.Point(xChange, yChange);
          this.canvas.relativePan(delta);
        }
        this.canvas.lastPosX = e.touches[0].clientX;
        this.canvas.lastPosY = e.touches[0].clientY;
        this.canvas.setCursor(this.canvas.defaultCursor);
      } else if (e.type === 'touchmove' && opt.e.touches.length === 3) {
        this.resetView()
      }
    });

    this.canvas.on('mouse:dblclick', (e: fabric.IEvent) => { this.resetView() });

  }


  ngAfterViewInit() {
    this.canvas = new fabric.Canvas('fabricCanvas', {
      //  backgroundColor: '#c0dfea',
      selection: false,
    });
    this.canvas.defaultCursor = 'move';
    this.resizeCanvas()
    window.addEventListener('resize', this.resizeCanvas.bind(this), false);
    this.gestureFabric()

  }

}



// WEBPACK FOOTER //
// ./src/app/damage-control/micro-canvas/micro-canvas.component.ts